var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"slave"}},[_c('header-bar',{staticClass:"sidebar-container"}),_vm._v(" "),_c('el-container',[_c('side-bar'),_vm._v(" "),_c('app-main')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-842317c0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/homenew/Home.vue
// module id = null
// module chunks = 